import { SwatchData, NewSwatch, SearchParams } from '../types'
import { http } from './http'

export const fetchSwatches = async (params: SearchParams): Promise<SwatchData> => {
  const { data } = await http.get<SwatchData>(`/v2/swatches`, { params })
  return data
}

export const createSwatch = async (newSwatch: NewSwatch) => {
  const { data } = await http.post<NewSwatch>('v2/swatches', newSwatch)
  return data
}
